(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[5405,269,9676],{

/***/ 94184:
/***/ (function(module, exports) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
	Copyright (c) 2018 Jed Watson.
	Licensed under the MIT License (MIT), see
	http://jedwatson.github.io/classnames
*/
/* global define */

(function () {
	'use strict';

	var hasOwn = {}.hasOwnProperty;
	var nativeCodeString = '[native code]';

	function classNames() {
		var classes = [];

		for (var i = 0; i < arguments.length; i++) {
			var arg = arguments[i];
			if (!arg) continue;

			var argType = typeof arg;

			if (argType === 'string' || argType === 'number') {
				classes.push(arg);
			} else if (Array.isArray(arg)) {
				if (arg.length) {
					var inner = classNames.apply(null, arg);
					if (inner) {
						classes.push(inner);
					}
				}
			} else if (argType === 'object') {
				if (arg.toString !== Object.prototype.toString && !arg.toString.toString().includes('[native code]')) {
					classes.push(arg.toString());
					continue;
				}

				for (var key in arg) {
					if (hasOwn.call(arg, key) && arg[key]) {
						classes.push(key);
					}
				}
			}
		}

		return classes.join(' ');
	}

	if ( true && module.exports) {
		classNames.default = classNames;
		module.exports = classNames;
	} else if (true) {
		// register as 'classnames', consistent with npm package name
		!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = (function () {
			return classNames;
		}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
		__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	} else {}
}());


/***/ }),

/***/ 89886:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/",
      function () {
        return __webpack_require__(39645);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 31121:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "H1": function() { return /* binding */ H1; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(69396);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(99534);
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(35944);
/* harmony import */ var _chakra_ui_react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(46052);
/* harmony import */ var _chakra_ui_react__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(68527);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);






var H1 = function(_param) {
    var children = _param.children, props = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_param, [
        "children"
    ]);
    var styles = (0,_chakra_ui_react__WEBPACK_IMPORTED_MODULE_2__/* .useStyleConfig */ .mq)("h1");
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__/* .jsx */ .tZ)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_4__/* .Box */ .xu, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)({
        as: "h1",
        __css: styles
    }, props), {
        children: children
    }));
};


/***/ }),

/***/ 34831:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(69396);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(99534);
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(35944);
/* harmony import */ var _emotion_styled__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(16829);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(41664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _styles__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(63319);




function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n        height: var(--chakra-sizes-8);\n        min-width: var(--chakra-sizes-8); \n        -webkit-padding-start: var(--chakra-space-3);\n        padding-inline-start: var(--chakra-space-3);\n        -webkit-padding-end: var(--chakra-space-3);\n        padding-inline-end: var(--chakra-space-3);     \n    "
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  display: inline-flex;\n  -webkit-appearance: none;\n  -moz-appearance: none;\n  -ms-appearance: none;\n  appearance: none;\n  -webkit-align-items: center;\n  -webkit-box-align: center;\n  -ms-flex-align: center;\n  align-items: center;\n  -webkit-box-pack: center;\n  -ms-flex-pack: center;\n  -webkit-justify-content: center;\n  justify-content: center;\n  -webkit-user-select: none;\n  -moz-user-select: none;\n  -ms-user-select: none;\n  user-select: none;\n  position: relative;\n  white-space: pre;\n  vertical-align: middle;\n  outline: 2px solid transparent;\n  outline-offset: 2px;\n  width: none;\n  line-height: 13px;\n  border-radius: 4.375rem;\n  font-weight: var(--chakra-fontWeights-normal);\n  transition-property: var(--chakra-transition-property-common);\n  transition-duration: var(--chakra-transition-duration-normal);\n  border: var(--chakra-borders-1px);\n  border-color: var(--chakra-colors-black);\n  height: var(--chakra-sizes-10);\n  min-width: var(--chakra-sizes-10);\n  -webkit-transition: 0.3s;\n  transition: 0.3s;\n  cursor: pointer;\n  font-size: 24px;\n  -webkit-padding-start: var(--chakra-space-4);\n  padding-inline-start: var(--chakra-space-4);\n  -webkit-padding-end: var(--chakra-space-4);\n  padding-inline-end: var(--chakra-space-4);\n  padding: 1rem 1.25rem;\n\n  &:hover {\n    background-color: ",
        " !important;\n    color: var(--chakra-colors-primary);\n    border: 0;\n  }\n\n  ",
        "\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}




var CustomLinkStyled = _emotion_styled__WEBPACK_IMPORTED_MODULE_1__/* ["default"].a */ .Z.a(_templateObject1(), function(props) {
    return props.hoverBackgroundColor || "var(--chakra-colors-tertiaryLight)";
}, _styles__WEBPACK_IMPORTED_MODULE_3__/* .media.mediumScreen */ .BC.mediumScreen(_templateObject()));
var CustomLink = function(_param) {
    var href = _param.href, children = _param.children, external = _param.external, hoverBackgroundColor = _param.hoverBackgroundColor, props = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(_param, [
        "href",
        "children",
        "external",
        "hoverBackgroundColor"
    ]);
    if (external) {
        return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsx */ .tZ)(CustomLinkStyled, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)({
            href: href,
            hoverBackgroundColor: hoverBackgroundColor
        }, props), {
            children: children
        }));
    }
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsx */ .tZ)((next_link__WEBPACK_IMPORTED_MODULE_2___default()), {
        href: href,
        passHref: true,
        children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsx */ .tZ)(CustomLinkStyled, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)({
            hoverBackgroundColor: hoverBackgroundColor
        }, props), {
            children: children
        }))
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (CustomLink);


/***/ }),

/***/ 39645:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSP": function() { return /* binding */ __N_SSP; },
  "default": function() { return /* binding */ pages; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_sliced_to_array.mjs + 2 modules
var _sliced_to_array = __webpack_require__(828);
// EXTERNAL MODULE: ./node_modules/@emotion/react/jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js
var emotion_react_jsx_runtime_browser_esm = __webpack_require__(35944);
// EXTERNAL MODULE: ./node_modules/@chakra-ui/media-query/dist/chakra-ui-media-query.esm.js
var chakra_ui_media_query_esm = __webpack_require__(92684);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/url-join/lib/url-join.js
var url_join = __webpack_require__(34078);
var url_join_default = /*#__PURE__*/__webpack_require__.n(url_join);
// EXTERNAL MODULE: ./src/paths.ts
var paths = __webpack_require__(4032);
;// CONCATENATED MODULE: ./src/core/SEO/Homepage/structuredData.constants.ts
var ContactPointEnum;
(function(ContactPointEnum) {
    ContactPointEnum["TYPE"] = "ContactPoint";
    ContactPointEnum["CONTACT_TYPE"] = "Customer Support";
    ContactPointEnum["TELEPHONE"] = "+61 1800 319 370";
    ContactPointEnum["EMAIL"] = "support@thevolte.com";
})(ContactPointEnum || (ContactPointEnum = {}));

;// CONCATENATED MODULE: ./src/core/SEO/Homepage/structuredData.tsx



var structuredWebsiteData = function(shop) {
    return JSON.stringify({
        "@context": "https://schema.org",
        "@type": "WebSite",
        name: "The Volte - Designer Dress Hire Australia - Rent Online",
        description: shop ? shop.description : "",
        potentialAction: {
            "@type": "SearchAction",
            "query-input": "required name=q",
            target: url_join_default()("https://thevolte.com", paths/* paths.search */.H.search, "?q={q}")
        },
        url: "https://thevolte.com",
        sameAs: [
            "https://www.facebook.com/thevolte",
            "https://twitter.com/the_volte",
            "http://pinterest.com/thevolte/",
            "http://www.linkedin.com/company/the-volte/",
            "https://en.wikipedia.org/wiki/The_Volte_(company)",
            "https://www.youtube.com/@TheVolte", 
        ]
    });
};
var structuredOrganizationData = function() {
    return JSON.stringify({
        "@context": "https://schema.org",
        "@type": "Organization",
        name: "The Volte",
        legalName: "The Volte Group Pty Ltd",
        url: "https://thevolte.com",
        logo: {
            "@type": "ImageObject",
            url: "https://thevolte.com/images/the_volte_logo_black.svg"
        },
        foundingDate: "2016",
        founders: [
            {
                "@type": "Person",
                name: "Bernadette Olivier"
            },
            {
                "@type": "Person",
                name: "Jade Hirniak"
            }, 
        ],
        address: {
            "@type": "PostalAddress",
            streetAddress: "1/4 Gugeri Street",
            addressLocality: "Claremont",
            addressRegion: "WA",
            postalCode: "6010",
            addressCountry: "AU"
        },
        contactPoint: {
            "@type": ContactPointEnum.TYPE,
            contactType: ContactPointEnum.CONTACT_TYPE,
            telephone: ContactPointEnum.TELEPHONE,
            email: ContactPointEnum.EMAIL
        },
        sameAs: [
            "https://www.facebook.com/thevolte",
            "https://twitter.com/the_volte",
            "http://pinterest.com/thevolte/",
            "http://www.linkedin.com/company/the-volte/",
            "https://en.wikipedia.org/wiki/The_Volte_(company)",
            "https://www.youtube.com/@TheVolte", 
        ]
    });
};

// EXTERNAL MODULE: ./node_modules/@chakra-ui/layout/dist/chakra-ui-layout.esm.js
var chakra_ui_layout_esm = __webpack_require__(68527);
// EXTERNAL MODULE: ./src/components/atoms/index.ts + 6 modules
var atoms = __webpack_require__(23920);
// EXTERNAL MODULE: ./src/components/molecules/index.ts + 68 modules
var molecules = __webpack_require__(27706);
// EXTERNAL MODULE: ./src/components/organisms/index.ts + 9 modules
var organisms = __webpack_require__(14254);
// EXTERNAL MODULE: ./src/components/legacy/index.ts + 40 modules
var legacy = __webpack_require__(92291);
// EXTERNAL MODULE: ./node_modules/@the-volte/svc-core-sdk/lib/index.js
var lib = __webpack_require__(44859);
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(25675);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
// EXTERNAL MODULE: ./src/components/atoms/Text/H1.tsx
var H1 = __webpack_require__(31121);
// EXTERNAL MODULE: ./src/components/organisms/Home/styles.tsx
var styles = __webpack_require__(34831);
;// CONCATENATED MODULE: ./src/components/organisms/Home/homepage-desktop/HeroSectionMain.tsx









var HeroSectionMain = function(param) {
    var handleWidthBasedOnHover = param.handleWidthBasedOnHover, position = param.position, hoveredSection = param.hoveredSection, setHoveredSection = param.setHoveredSection, imageSrc = param.imageSrc, ctaTitle = param.ctaTitle, ctaButton = param.ctaButton, alignItems = param.alignItems, onClickCtaAction = param.onClickCtaAction, altTitleColor = param.altTitleColor;
    var user = (0,lib.useAuth)().user;
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(chakra_ui_layout_esm/* Box */.xu, {
        width: handleWidthBasedOnHover(position, hoveredSection),
        height: "full",
        bgColor: "#454545",
        overflow: "hidden",
        position: "relative",
        style: {
            transition: "all 0.5s"
        },
        onMouseEnter: function() {
            return setHoveredSection(position);
        },
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)((image_default()), {
                style: {
                    height: "100%"
                },
                layout: "responsive",
                src: imageSrc,
                alt: "".concat(position, " - hero"),
                priority: true
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(chakra_ui_layout_esm/* Box */.xu, {
                color: "black",
                display: "flex",
                flexDirection: "row",
                w: "full",
                h: "full",
                position: "absolute",
                top: "0",
                padding: "1.875rem 1.875rem",
                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(chakra_ui_layout_esm/* Box */.xu, {
                    w: "full",
                    display: "flex",
                    flexDirection: "column",
                    alignItems: alignItems,
                    children: [
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(H1.H1, {
                            as: "span",
                            color: altTitleColor ? "#000" : "#fff",
                            fontSize: "2.75rem",
                            lineHeight: "3rem",
                            children: ctaTitle
                        }),
                        ctaButton.includes("Become a lender") ? /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(styles/* default */.Z, {
                            external: true,
                            href: !user ? paths/* paths.login */.H.login : (user === null || user === void 0 ? void 0 : user.defaultShippingAddress) ? paths/* paths.accountLending */.H.accountLending : "".concat(paths/* paths.accountAddressBook */.H.accountAddressBook, "?fromLending=true"),
                            style: {
                                paddingLeft: "25px",
                                paddingRight: "30px",
                                marginTop: "20px",
                                backgroundColor: "#ffffff66",
                                color: "#fff",
                                border: "none"
                            },
                            hoverBackgroundColor: "#ffffff66",
                            children: ctaButton
                        }) : /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(atoms.Button, {
                            size: "md",
                            fontSize: "24px",
                            pl: "25px",
                            pr: "30px",
                            mt: "20px",
                            variant: "secondary",
                            onClick: function() {
                                return onClickCtaAction === null || onClickCtaAction === void 0 ? void 0 : onClickCtaAction();
                            },
                            bgColor: altTitleColor ? "#8d8d8d66" : "#ffffff66",
                            border: "none",
                            color: altTitleColor ? "#000" : "#fff",
                            _hover: {
                                bg: "#ffffff66"
                            },
                            children: ctaButton
                        })
                    ]
                })
            })
        ]
    });
};
/* harmony default export */ var homepage_desktop_HeroSectionMain = (HeroSectionMain);

// EXTERNAL MODULE: ./node_modules/react-svg/dist/react-svg.esm.js + 1 modules
var react_svg_esm = __webpack_require__(98547);
// EXTERNAL MODULE: ./src/images/the_volte_logo_black.svg
var the_volte_logo_black = __webpack_require__(6643);
;// CONCATENATED MODULE: ./src/components/organisms/Home/homepage-desktop/HeroSectionTitle.tsx





var HeroSectionTitle = function() {
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(chakra_ui_layout_esm/* Box */.xu, {
        backgroundColor: "#ffffff63",
        position: "absolute",
        display: "flex",
        justifyContent: "center",
        width: "100%",
        color: "#FFF",
        left: "50%",
        transform: "translate(-50%, 0)",
        top: "70%",
        textAlign: "center",
        textTransform: "uppercase",
        zIndex: 10,
        height: "18rem",
        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(chakra_ui_layout_esm/* Box */.xu, {
            w: [
                null,
                null,
                "70rem",
                "60rem"
            ],
            children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(react_svg_esm/* ReactSVG */.Q, {
                src: the_volte_logo_black/* default.src */.Z.src
            })
        })
    });
};
/* harmony default export */ var homepage_desktop_HeroSectionTitle = (HeroSectionTitle);

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/@chakra-ui/progress/dist/chakra-ui-progress.esm.js
var chakra_ui_progress_esm = __webpack_require__(38152);
// EXTERNAL MODULE: ./node_modules/date-fns/esm/isValid/index.js + 1 modules
var isValid = __webpack_require__(61436);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./src/components/organisms/Quiz/steps/SelectDeliveryDate.tsx
var SelectDeliveryDate = __webpack_require__(77901);
// EXTERNAL MODULE: ./src/components/organisms/Quiz/steps/SelectShipping.tsx
var SelectShipping = __webpack_require__(44395);
// EXTERNAL MODULE: ./src/components/organisms/Quiz/steps/SelectSize.tsx
var SelectSize = __webpack_require__(85572);
// EXTERNAL MODULE: ./src/components/organisms/Quiz/SubmitButton.tsx
var SubmitButton = __webpack_require__(24263);
// EXTERNAL MODULE: ./src/hooks/useProductFiltering.ts
var useProductFiltering = __webpack_require__(27698);
// EXTERNAL MODULE: ./src/images/arrow-left-new.svg
var arrow_left_new = __webpack_require__(10549);
// EXTERNAL MODULE: ./src/images/x-black.svg
var x_black = __webpack_require__(46442);
;// CONCATENATED MODULE: ./src/components/organisms/Quiz/ShortQuiz.tsx

















var ShortQuiz = function() {
    var overlay = (0,react.useContext)(legacy.OverlayContext);
    var ref = (0,react.useState)(0), step = ref[0], setStep = ref[1];
    var ref1 = (0,useProductFiltering/* default */.Z)(), deliveryFilter = ref1.deliveryFilter, setDeliveryFilter = ref1.setDeliveryFilter;
    var DEFAULT_DATE = (0,isValid/* default */.Z)(new Date(deliveryFilter === null || deliveryFilter === void 0 ? void 0 : deliveryFilter.date)) ? new Date(deliveryFilter === null || deliveryFilter === void 0 ? void 0 : deliveryFilter.date) : undefined;
    var ref2 = (0,react.useState)(DEFAULT_DATE), date = ref2[0], setDate = ref2[1];
    var ref3 = (0,react.useState)([]), selectedSizes = ref3[0], setSelectedSizes = ref3[1];
    var router = (0,next_router.useRouter)();
    var handlePostChange = function(postCode) {
        setDeliveryFilter(function(_deliveryFilter) {
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, _deliveryFilter), {
                postCode: postCode
            });
        });
    };
    var handleDateChange = function(_date) {
        setDate(_date);
        setDeliveryFilter(function(_deliveryFilter) {
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, _deliveryFilter), {
                date: new Date(_date).toISOString().substring(0, 10)
            });
        });
    };
    var handleNextStep = function() {
        if (step === 2) {
            router.push("".concat(paths/* paths.defaultCategory */.H.defaultCategory, "?filters=size_").concat(selectedSizes.join("_")));
            overlay.hide();
            return;
        }
        setStep(function(_step) {
            return _step + 1;
        });
    };
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(chakra_ui_layout_esm/* Box */.xu, {
        bgColor: "white",
        position: "absolute",
        top: "50%",
        left: "50%",
        transform: "translate(-50%, -50%)",
        display: "flex",
        flexDirection: "column",
        zIndex: 1100,
        width: [
            "100%",
            null,
            null,
            "38rem"
        ],
        height: [
            "100%",
            null,
            null,
            "45rem"
        ],
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(chakra_ui_progress_esm/* Progress */.Ex, {
                value: (step + 1) * 100 / 4
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(chakra_ui_layout_esm/* Box */.xu, {
                p: [
                    "1rem",
                    null,
                    null,
                    "2rem"
                ],
                w: "full",
                h: "full",
                display: "flex",
                flexDirection: "column",
                children: [
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(chakra_ui_layout_esm/* Box */.xu, {
                        display: "flex",
                        justifyContent: "space-between",
                        children: [
                            step !== 0 ? /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(chakra_ui_layout_esm/* Box */.xu, {
                                onClick: function() {
                                    return setStep(function(_step) {
                                        return _step - 1;
                                    });
                                },
                                cursor: "pointer",
                                display: "flex",
                                color: "gray",
                                children: [
                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(chakra_ui_layout_esm/* Box */.xu, {
                                        w: "0.8rem",
                                        cursor: "pointer",
                                        mr: "0.5rem",
                                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(react_svg_esm/* ReactSVG */.Q, {
                                            src: arrow_left_new/* default.src */.Z.src
                                        })
                                    }),
                                    "BACK"
                                ]
                            }) : /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(chakra_ui_layout_esm/* Box */.xu, {}),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(chakra_ui_layout_esm/* Box */.xu, {
                                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(chakra_ui_layout_esm/* Box */.xu, {
                                    display: "flex",
                                    justifyContent: "flex-end",
                                    cursor: "pointer",
                                    onClick: function() {
                                        return overlay.hide();
                                    },
                                    children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(react_svg_esm/* ReactSVG */.Q, {
                                        src: x_black/* default.src */.Z.src
                                    })
                                })
                            })
                        ]
                    }),
                    step === 0 && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(SelectSize/* default */.Z, {
                        selectedSizes: selectedSizes,
                        setSelectedSizes: setSelectedSizes,
                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(SubmitButton/* default */.Z, {
                            handleNextStep: handleNextStep,
                            label: selectedSizes.length === 0 ? "SKIP" : "NEXT"
                        })
                    }),
                    step === 1 && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(SelectShipping/* default */.Z, {
                        postCode: deliveryFilter === null || deliveryFilter === void 0 ? void 0 : deliveryFilter.postCode,
                        handlePostChange: handlePostChange,
                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(SubmitButton/* default */.Z, {
                            handleNextStep: handleNextStep,
                            label: (deliveryFilter === null || deliveryFilter === void 0 ? void 0 : deliveryFilter.postCode) ? "NEXT" : "SKIP"
                        })
                    }),
                    step === 2 && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(SelectDeliveryDate/* default */.Z, {
                        date: date,
                        setDate: handleDateChange,
                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(SubmitButton/* default */.Z, {
                            handleNextStep: handleNextStep,
                            label: date ? "NEXT" : "SKIP"
                        })
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var Quiz_ShortQuiz = (ShortQuiz);

// EXTERNAL MODULE: ./src/hooks/useRedirectToDashboard.ts
var useRedirectToDashboard = __webpack_require__(27314);
// EXTERNAL MODULE: ./src/globalStyles/constants.ts
var constants = __webpack_require__(71467);
;// CONCATENATED MODULE: ./src/images/hero/hero_desktop_left_5.jpg
/* harmony default export */ var hero_desktop_left_5 = ({"src":"/_next/static/media/hero_desktop_left_5.124bfb24.jpg","height":1956,"width":928,"blurDataURL":"data:image/jpeg;base64,/9j/2wBDAAoHBwgHBgoICAgLCgoLDhgQDg0NDh0VFhEYIx8lJCIfIiEmKzcvJik0KSEiMEExNDk7Pj4+JS5ESUM8SDc9Pjv/2wBDAQoLCw4NDhwQEBw7KCIoOzs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozv/wAARCAAIAAQDASIAAhEBAxEB/8QAFQABAQAAAAAAAAAAAAAAAAAAAAb/xAAcEAACAgIDAAAAAAAAAAAAAAABAgADBSEEEkH/xAAVAQEBAAAAAAAAAAAAAAAAAAAEBf/EABkRAAIDAQAAAAAAAAAAAAAAAAABAhIhMf/aAAwDAQACEQMRAD8AjLxiWWgU4vnlkqVbXNoXu/rAb1ERC2ZfUc6f/9k=","blurWidth":4,"blurHeight":8});
;// CONCATENATED MODULE: ./src/images/hero/hero_desktop_right_5.jpg
/* harmony default export */ var hero_desktop_right_5 = ({"src":"/_next/static/media/hero_desktop_right_5.c359a519.jpg","height":1401,"width":639,"blurDataURL":"data:image/jpeg;base64,/9j/2wBDAAoHBwgHBgoICAgLCgoLDhgQDg0NDh0VFhEYIx8lJCIfIiEmKzcvJik0KSEiMEExNDk7Pj4+JS5ESUM8SDc9Pjv/2wBDAQoLCw4NDhwQEBw7KCIoOzs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozv/wAARCAAIAAQDASIAAhEBAxEB/8QAFQABAQAAAAAAAAAAAAAAAAAAAAb/xAAgEAABAwIHAAAAAAAAAAAAAAAAAgMEAQURISIlM2KB/8QAFQEBAQAAAAAAAAAAAAAAAAAAAwX/xAAYEQACAwAAAAAAAAAAAAAAAAAAAQISQf/aAAwDAQACEQMRAD8AgXIF5Quu2yXcc+BWnr4AACtaS0//2Q==","blurWidth":4,"blurHeight":8});
;// CONCATENATED MODULE: ./src/images/hero/hero_desktop_wide_left_5.jpg
/* harmony default export */ var hero_desktop_wide_left_5 = ({"src":"/_next/static/media/hero_desktop_wide_left_5.e5accdfe.jpg","height":2331,"width":2090,"blurDataURL":"data:image/jpeg;base64,/9j/2wBDAAoHBwgHBgoICAgLCgoLDhgQDg0NDh0VFhEYIx8lJCIfIiEmKzcvJik0KSEiMEExNDk7Pj4+JS5ESUM8SDc9Pjv/2wBDAQoLCw4NDhwQEBw7KCIoOzs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozv/wAARCAAIAAcDASIAAhEBAxEB/8QAFQABAQAAAAAAAAAAAAAAAAAAAAb/xAAgEAABAwIHAAAAAAAAAAAAAAABAAIDERMEBQYVIVGB/8QAFQEBAQAAAAAAAAAAAAAAAAAAAwb/xAAYEQEBAAMAAAAAAAAAAAAAAAABAAMRUf/aAAwDAQACEQMRAD8AiJNkZp8Yek8mb3iTK0G21nFB0aj0EIiIGocQI77f/9k=","blurWidth":7,"blurHeight":8});
;// CONCATENATED MODULE: ./src/images/hero/hero_desktop_wide_right_5.jpg
/* harmony default export */ var hero_desktop_wide_right_5 = ({"src":"/_next/static/media/hero_desktop_wide_right_5.3a2a7e58.jpg","height":2156,"width":1237,"blurDataURL":"data:image/jpeg;base64,/9j/2wBDAAoHBwgHBgoICAgLCgoLDhgQDg0NDh0VFhEYIx8lJCIfIiEmKzcvJik0KSEiMEExNDk7Pj4+JS5ESUM8SDc9Pjv/2wBDAQoLCw4NDhwQEBw7KCIoOzs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozv/wAARCAAIAAUDASIAAhEBAxEB/8QAFQABAQAAAAAAAAAAAAAAAAAAAAf/xAAgEAABAwIHAAAAAAAAAAAAAAAAAgQRAyEFEhMiQYGh/8QAFQEBAQAAAAAAAAAAAAAAAAAAAwX/xAAWEQEBAQAAAAAAAAAAAAAAAAAAARL/2gAMAwEAAhEDEQA/AJ9WZYslVmLlea8aKtnEeT2AAFbVj//Z","blurWidth":5,"blurHeight":8});
;// CONCATENATED MODULE: ./src/components/organisms/Home/homepage-desktop/HeroSectionDesktop.tsx














var handleWidthBasedOnHover = function(position, hoveredSection) {
    if (hoveredSection === "none") {
        return "50%";
    }
    if (position === hoveredSection) {
        return "53%";
    }
    return "47%";
};
var HeroSectionDesktop = function() {
    var redirectToDashboard = (0,useRedirectToDashboard/* default */.Z)().redirectToDashboard;
    var ref = (0,react.useState)("none"), hoveredSection = ref[0], setHoveredSection = ref[1];
    var overlay = react.useContext(legacy.OverlayContext);
    var ref1 = (0,_sliced_to_array/* default */.Z)((0,chakra_ui_media_query_esm/* useMediaQuery */.ac)("(min-width: ".concat(constants/* breakpoints.xxl */.AV.xxl, ")")), 1), isDesktopWide = ref1[0];
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(chakra_ui_layout_esm/* Flex */.kC, {
        w: "100%",
        h: "800px",
        position: "relative",
        display: "flex",
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(homepage_desktop_HeroSectionMain, {
                setHoveredSection: setHoveredSection,
                position: "left",
                hoveredSection: hoveredSection,
                handleWidthBasedOnHover: handleWidthBasedOnHover,
                ctaTitle: "SHARE THE DRESS",
                ctaButton: "Become a lender \xa0\xa0⟶",
                onClickCtaAction: redirectToDashboard,
                imageSrc: isDesktopWide ? hero_desktop_wide_left_5 : hero_desktop_left_5,
                alignItems: "end"
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(homepage_desktop_HeroSectionMain, {
                onClickCtaAction: function() {
                    return overlay.toggle(legacy.OverlayType.modal, undefined, {
                        content: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Quiz_ShortQuiz, {})
                    });
                },
                setHoveredSection: setHoveredSection,
                position: "right",
                hoveredSection: hoveredSection,
                handleWidthBasedOnHover: handleWidthBasedOnHover,
                ctaTitle: "WEAR THE DRESS",
                ctaButton: "Rent the collection\xa0\xa0⟶",
                imageSrc: isDesktopWide ? hero_desktop_wide_right_5 : hero_desktop_right_5,
                alignItems: "end"
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(chakra_ui_layout_esm/* Box */.xu, {
                backgroundColor: "transparent",
                position: "absolute",
                width: "100%",
                height: "70%",
                left: "50%",
                transform: "translate(-50%, 0)",
                top: "30%",
                display: "flex",
                zIndex: 100,
                children: [
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(chakra_ui_layout_esm/* Box */.xu, {
                        width: handleWidthBasedOnHover("left", hoveredSection),
                        height: "full",
                        overflow: "hidden",
                        position: "relative",
                        onMouseEnter: function() {
                            return setHoveredSection("left");
                        }
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(chakra_ui_layout_esm/* Box */.xu, {
                        width: handleWidthBasedOnHover("right", hoveredSection),
                        height: "full",
                        overflow: "hidden",
                        position: "relative",
                        onMouseEnter: function() {
                            return setHoveredSection("right");
                        }
                    })
                ]
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(homepage_desktop_HeroSectionTitle, {})
        ]
    });
};
/* harmony default export */ var homepage_desktop_HeroSectionDesktop = (HeroSectionDesktop);

;// CONCATENATED MODULE: ./src/components/pages/Home/HomePageDesktop.tsx







var HomePageDesktop = function(param) {
    var collection = param.collection, collections = param.collections;
    var ref;
    var ref1 = collection || {}, description = ref1.description, products = ref1.products;
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(chakra_ui_layout_esm/* Flex */.kC, {
        flexDirection: "column",
        overflow: "hidden",
        alignItems: "center",
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(homepage_desktop_HeroSectionDesktop, {}),
            collections && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(organisms/* CollectionGrid */.Uz, {
                collections: collections
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(chakra_ui_layout_esm/* Grid */.rj, {
                w: "100%",
                templateColumns: [
                    "repeat(2, 1fr)",
                    "repeat(2, 1fr)",
                    null,
                    null,
                    "repeat(2, 1fr)",
                    "repeat(3, 1fr)",
                    "repeat(4, 1fr)", 
                ],
                gap: 6,
                padding: [
                    "1.5rem 0 0.93rem 0.93rem",
                    null,
                    null,
                    "3.75rem"
                ],
                rowGap: 14,
                children: products === null || products === void 0 ? void 0 : (ref = products.edges) === null || ref === void 0 ? void 0 : ref.map(function(product) {
                    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(molecules/* ProductTile */.vB, {
                        product: product.node
                    }, product.node.id);
                })
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(organisms/* FeaturedDesigners */.N0, {
                isDesktop: true,
                title: "FEATURED DESIGNERS",
                ctaText: "View all designers →",
                content: "Browse collections from The Volte's favourite designers and discover hot new brands we know you will love."
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(organisms/* SeamlessLending */.lS, {}),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(organisms/* CircularPartners */.x, {}),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(organisms/* AsSeenIn */.I, {}),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(chakra_ui_layout_esm/* Box */.xu, {
                p: "5rem 10rem",
                bgColor: "secondary",
                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(atoms.RichTextEditorContent, {
                    jsonData: description,
                    sanitizationNotRequired: true
                })
            })
        ]
    });
};
/* harmony default export */ var Home_HomePageDesktop = (HomePageDesktop);

// EXTERNAL MODULE: ./src/hooks/useLocalStorage.tsx
var useLocalStorage = __webpack_require__(83319);
;// CONCATENATED MODULE: ./src/images/hero/hero_mobile_left_5.jpg
/* harmony default export */ var hero_mobile_left_5 = ({"src":"/_next/static/media/hero_mobile_left_5.6eda3d1a.jpg","height":1200,"width":1000,"blurDataURL":"data:image/jpeg;base64,/9j/2wBDAAoHBwgHBgoICAgLCgoLDhgQDg0NDh0VFhEYIx8lJCIfIiEmKzcvJik0KSEiMEExNDk7Pj4+JS5ESUM8SDc9Pjv/2wBDAQoLCw4NDhwQEBw7KCIoOzs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozv/wAARCAAIAAcDASIAAhEBAxEB/8QAFQABAQAAAAAAAAAAAAAAAAAAAAb/xAAgEAABAwIHAAAAAAAAAAAAAAABAAIDBSEEBhESMUFh/8QAFQEBAQAAAAAAAAAAAAAAAAAAAwX/xAAYEQEAAwEAAAAAAAAAAAAAAAABAAMRUf/aAAwDAQACEQMRAD8AigaFHl92GlE8lWdNqJGA7I2W74IN/QUREDL9Ro72f//Z","blurWidth":7,"blurHeight":8});
;// CONCATENATED MODULE: ./src/images/hero/hero_mobile_right_5.jpg
/* harmony default export */ var hero_mobile_right_5 = ({"src":"/_next/static/media/hero_mobile_right_5.e8891aa4.jpg","height":1200,"width":1000,"blurDataURL":"data:image/jpeg;base64,/9j/2wBDAAoHBwgHBgoICAgLCgoLDhgQDg0NDh0VFhEYIx8lJCIfIiEmKzcvJik0KSEiMEExNDk7Pj4+JS5ESUM8SDc9Pjv/2wBDAQoLCw4NDhwQEBw7KCIoOzs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozv/wAARCAAIAAcDASIAAhEBAxEB/8QAFQABAQAAAAAAAAAAAAAAAAAAAAf/xAAeEAABBAEFAAAAAAAAAAAAAAABAAIDEQQSITGBof/EABUBAQEAAAAAAAAAAAAAAAAAAAMF/8QAFhEBAQEAAAAAAAAAAAAAAAAAAAER/9oADAMBAAIRAxEAPwCdTDNAa4RyEO2DNBttcnu/ERECxtj/2Q==","blurWidth":7,"blurHeight":8});
;// CONCATENATED MODULE: ./src/components/organisms/Home/homepage-mobile/HeroSectionMobile.tsx













var HeroSectionMobile = function() {
    var overlay = (0,react.useContext)(legacy.OverlayContext);
    var user = (0,lib.useAuth)().user;
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(chakra_ui_layout_esm/* Box */.xu, {
                width: "100%",
                height: "full",
                bgColor: "#454545",
                overflow: "hidden",
                position: "relative",
                children: [
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)((image_default()), {
                        layout: "responsive",
                        src: hero_mobile_right_5,
                        alt: "hero mobile right",
                        priority: true
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(chakra_ui_layout_esm/* Box */.xu, {
                        color: "black",
                        display: "flex",
                        flexDirection: "row",
                        w: "full",
                        h: "full",
                        position: "absolute",
                        top: "0",
                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(chakra_ui_layout_esm/* Box */.xu, {
                            w: "full",
                            display: "flex",
                            flexDirection: "column",
                            alignItems: "start",
                            justifyContent: "flex-end",
                            children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(chakra_ui_layout_esm/* Box */.xu, {
                                w: "full",
                                backgroundColor: "#ffffff63",
                                display: "flex",
                                flexDirection: "column",
                                justifyContent: "flex-end",
                                alignItems: "start",
                                paddingTop: "0.75rem",
                                paddingBottom: "0.75rem",
                                paddingX: "0.75rem",
                                children: [
                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(H1.H1, {
                                        as: "span",
                                        color: "#000",
                                        fontSize: "3.1rem",
                                        letterSpacing: "unset",
                                        lineHeight: 1,
                                        children: "WEAR THE DRESS"
                                    }),
                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(atoms.Button, {
                                        size: "sm",
                                        fontSize: "17px",
                                        mt: "8px",
                                        pl: "20px",
                                        pr: "20px",
                                        variant: "ternary",
                                        bgColor: "#ffffff66",
                                        border: "none",
                                        color: "#000",
                                        onClick: function() {
                                            return overlay.toggle(legacy.OverlayType.modal, undefined, {
                                                content: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Quiz_ShortQuiz, {})
                                            });
                                        },
                                        children: "Rent the collection \xa0\xa0⟶"
                                    })
                                ]
                            })
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(chakra_ui_layout_esm/* Box */.xu, {
                width: "100%",
                height: "full",
                bgColor: "#454545",
                overflow: "hidden",
                position: "relative",
                children: [
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)((image_default()), {
                        layout: "responsive",
                        src: hero_mobile_left_5,
                        alt: "hero mobile left",
                        priority: true
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(chakra_ui_layout_esm/* Box */.xu, {
                        display: "flex",
                        flexDirection: "row",
                        w: "full",
                        h: "full",
                        position: "absolute",
                        top: "0",
                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(chakra_ui_layout_esm/* Box */.xu, {
                            w: "full",
                            display: "flex",
                            flexDirection: "column",
                            alignItems: "start",
                            justifyContent: "flex-end",
                            children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(chakra_ui_layout_esm/* Box */.xu, {
                                w: "full",
                                backgroundColor: "#ffffff63",
                                display: "flex",
                                flexDirection: "column",
                                justifyContent: "flex-end",
                                alignItems: "start",
                                paddingTop: "0.75rem",
                                paddingBottom: "0.75rem",
                                paddingX: "0.75rem",
                                children: [
                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(H1.H1, {
                                        as: "span",
                                        color: "#000",
                                        fontSize: "3.1rem",
                                        letterSpacing: "unset",
                                        lineHeight: 1,
                                        children: "SHARE THE DRESS"
                                    }),
                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(styles/* default */.Z, {
                                        external: true,
                                        href: !user ? paths/* paths.login */.H.login : (user === null || user === void 0 ? void 0 : user.defaultShippingAddress) ? paths/* paths.accountLending */.H.accountLending : "".concat(paths/* paths.accountAddressBook */.H.accountAddressBook, "?fromLending=true"),
                                        style: {
                                            fontSize: "17px",
                                            paddingLeft: "20px",
                                            paddingRight: "20px",
                                            marginTop: "16px",
                                            backgroundColor: "#ffffff66",
                                            color: "#000",
                                            border: "none"
                                        },
                                        hoverBackgroundColor: "#ffffff66",
                                        children: "Become a lender \xa0\xa0⟶"
                                    })
                                ]
                            })
                        })
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var homepage_mobile_HeroSectionMobile = (HeroSectionMobile);

;// CONCATENATED MODULE: ./src/components/pages/Home/HomePage.tsx







var HomePage = function(param) {
    var collection = param.collection, collections = param.collections;
    var ref;
    var ref1 = collection || {}, description = ref1.description, products = ref1.products;
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(chakra_ui_layout_esm/* Flex */.kC, {
        flexDirection: "column",
        overflow: "hidden",
        alignItems: "center",
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(homepage_mobile_HeroSectionMobile, {}),
            collections && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(organisms/* CollectionGrid */.Uz, {
                collections: collections
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(chakra_ui_layout_esm/* Grid */.rj, {
                w: "100%",
                templateColumns: [
                    "repeat(2, 1fr)",
                    "repeat(2, 1fr)",
                    null,
                    null,
                    "repeat(3, 1fr)",
                    "repeat(4, 1fr)", 
                ],
                gap: 3,
                padding: [
                    "0.93rem",
                    null,
                    null,
                    "3.75rem"
                ],
                rowGap: 14,
                children: products === null || products === void 0 ? void 0 : (ref = products.edges) === null || ref === void 0 ? void 0 : ref.map(function(product) {
                    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(molecules/* ProductTile */.vB, {
                        product: product.node,
                        isMobile: true
                    }, product.node.id);
                })
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(chakra_ui_layout_esm/* Box */.xu, {
                width: "100%",
                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(organisms/* FeaturedDesigners */.N0, {
                    title: "FEATURED DESIGNERS",
                    ctaText: "View all designers →",
                    content: "Browse collections from The Volte's favourite designers and discover hot new brands we know you will love."
                })
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(organisms/* SeamlessLending */.lS, {}),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(organisms/* CircularPartners */.x, {}),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(organisms/* AsSeenIn */.I, {}),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(chakra_ui_layout_esm/* Box */.xu, {
                padding: "30px 15px 30px 15px",
                bgColor: "secondary",
                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(atoms.RichTextEditorContent, {
                    jsonData: description,
                    sanitizationNotRequired: true
                })
            })
        ]
    });
};
/* harmony default export */ var Home_HomePage = (HomePage);

;// CONCATENATED MODULE: ./src/views/Home/HomeView.tsx










var HomeView = function(param) {
    var _data = param.data, shop = _data.shop, collection = _data.collection, collections = _data.collections, marketplaces = _data.marketplaces;
    var ref, ref1, ref2, ref3, ref4, ref5;
    var ref6 = (0,_sliced_to_array/* default */.Z)((0,chakra_ui_media_query_esm/* useMediaQuery */.ac)("(min-width: ".concat(constants/* breakpoints.md */.AV.md, ")")), 1), isDesktop = ref6[0];
    var ref7 = (0,_sliced_to_array/* default */.Z)((0,useLocalStorage/* useLocalStorageQuiet */.k)("scrollOffset", {}), 2), setScrollState = ref7[1];
    // Reset scroll positions for all product list pages when mounting home
    (0,react.useEffect)(function() {
        setScrollState({});
    });
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("script", {
                className: "structured-data-list",
                type: "application/ld+json",
                // eslint-disable-next-line react/no-danger
                dangerouslySetInnerHTML: {
                    __html: structuredWebsiteData(shop)
                }
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("script", {
                className: "structured-data-list",
                type: "application/ld+json",
                // eslint-disable-next-line react/no-danger
                dangerouslySetInnerHTML: {
                    __html: structuredOrganizationData()
                }
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(legacy.MetaWrapper, {
                meta: {
                    description: (shop === null || shop === void 0 ? void 0 : shop.description) || "",
                    title: shop.name || "",
                    image: collection === null || collection === void 0 ? void 0 : (ref = collection.products) === null || ref === void 0 ? void 0 : (ref1 = ref.edges) === null || ref1 === void 0 ? void 0 : (ref2 = ref1[0]) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.node) === null || ref3 === void 0 ? void 0 : (ref4 = ref3.thumbnail2x) === null || ref4 === void 0 ? void 0 : ref4.url,
                    language: (shop === null || shop === void 0 ? void 0 : shop.language) || undefined,
                    canonicalUrl: shop === null || shop === void 0 ? void 0 : (ref5 = shop.domain) === null || ref5 === void 0 ? void 0 : ref5.url,
                    marketplaces: marketplaces
                },
                children: isDesktop ? /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Home_HomePageDesktop, {
                    collection: collection,
                    collections: collections,
                    shop: shop
                }) : /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Home_HomePage, {
                    collection: collection,
                    collections: collections,
                    shop: shop
                })
            })
        ]
    });
};

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/graphql-tag/lib/index.js + 6 modules
var graphql_tag_lib = __webpack_require__(22841);
// EXTERNAL MODULE: ./src/graphql/fragments.ts
var fragments = __webpack_require__(7905);
;// CONCATENATED MODULE: ./src/views/Home/queries.ts

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        "\n  query HomePageProducts($channel: String) {\n    marketplaces {\n      marketplace\n      language\n      siteUrl\n    }\n    shop(channel: $channel) {\n      description\n      name\n      marketplace\n      language\n      domain {\n        url\n        host\n      }\n    }\n    ...FeaturedProducts\n    categories(level: 0, first: 4) {\n      edges {\n        node {\n          id\n          name\n          slug\n          backgroundImage {\n            url\n          }\n        }\n      }\n    }\n    collections(\n      first: 15\n      filter: { isFeatured: true }\n      sortBy: { channel: $channel, direction: ASC, field: FEATURED_POSITION }\n    ) {\n      edges {\n        node {\n          slug\n          name\n          shortName\n          description\n          backgroundImage {\n            url\n            alt\n          }\n          backgroundDesktopImage {\n            url\n            alt\n          }\n          seoTitle\n          seoDescription\n        }\n      }\n    }\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}


var homePageProductsQuery = (0,graphql_tag_lib["default"])(_templateObject(), fragments/* featuredProductsFragment */.Sx);

;// CONCATENATED MODULE: ./src/views/Home/index.tsx



;// CONCATENATED MODULE: ./src/pages/index.ts

var __N_SSP = true;
// ts-prune-ignore-next
/* harmony default export */ var pages = (HomeView);


/***/ }),

/***/ 34078:
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (name, context, definition) {
  if ( true && module.exports) module.exports = definition();
  else if (true) !(__WEBPACK_AMD_DEFINE_FACTORY__ = (definition),
		__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
		(__WEBPACK_AMD_DEFINE_FACTORY__.call(exports, __webpack_require__, exports, module)) :
		__WEBPACK_AMD_DEFINE_FACTORY__),
		__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  else {}
})('urljoin', this, function () {

  function normalize (strArray) {
    var resultArray = [];
    if (strArray.length === 0) { return ''; }

    if (typeof strArray[0] !== 'string') {
      throw new TypeError('Url must be a string. Received ' + strArray[0]);
    }

    // If the first part is a plain protocol, we combine it with the next part.
    if (strArray[0].match(/^[^/:]+:\/*$/) && strArray.length > 1) {
      var first = strArray.shift();
      strArray[0] = first + strArray[0];
    }

    // There must be two or three slashes in the file protocol, two slashes in anything else.
    if (strArray[0].match(/^file:\/\/\//)) {
      strArray[0] = strArray[0].replace(/^([^/:]+):\/*/, '$1:///');
    } else {
      strArray[0] = strArray[0].replace(/^([^/:]+):\/*/, '$1://');
    }

    for (var i = 0; i < strArray.length; i++) {
      var component = strArray[i];

      if (typeof component !== 'string') {
        throw new TypeError('Url must be a string. Received ' + component);
      }

      if (component === '') { continue; }

      if (i > 0) {
        // Removing the starting slashes for each component but the first.
        component = component.replace(/^[\/]+/, '');
      }
      if (i < strArray.length - 1) {
        // Removing the ending slashes for each component but the last.
        component = component.replace(/[\/]+$/, '');
      } else {
        // For the last component we will combine multiple slashes to a single one.
        component = component.replace(/[\/]+$/, '/');
      }

      resultArray.push(component);

    }

    var str = resultArray.join('/');
    // Each input component is now separated by a single slash except the possible first plain protocol part.

    // remove trailing slash before parameters or hash
    str = str.replace(/\/(\?|&|#[^!])/g, '$1');

    // replace ? in parameters with &
    var parts = str.split('?');
    str = parts.shift() + (parts.length > 0 ? '?': '') + parts.join('&');

    return str;
  }

  return function () {
    var input;

    if (typeof arguments[0] === 'object') {
      input = arguments[0];
    } else {
      input = [].slice.call(arguments);
    }

    return normalize(input);
  };

});


/***/ }),

/***/ 25054:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "w_": function() { return /* reexport */ GenIcon; }
});

// UNUSED EXPORTS: DefaultContext, IconBase, IconContext, IconsManifest

;// CONCATENATED MODULE: ./node_modules/react-icons/lib/iconsManifest.mjs
var IconsManifest = [
  {
    "id": "ci",
    "name": "Circum Icons",
    "projectUrl": "https://circumicons.com/",
    "license": "MPL-2.0 license",
    "licenseUrl": "https://github.com/Klarr-Agency/Circum-Icons/blob/main/LICENSE"
  },
  {
    "id": "fa",
    "name": "Font Awesome 5",
    "projectUrl": "https://fontawesome.com/",
    "license": "CC BY 4.0 License",
    "licenseUrl": "https://creativecommons.org/licenses/by/4.0/"
  },
  {
    "id": "fa6",
    "name": "Font Awesome 6",
    "projectUrl": "https://fontawesome.com/",
    "license": "CC BY 4.0 License",
    "licenseUrl": "https://creativecommons.org/licenses/by/4.0/"
  },
  {
    "id": "io",
    "name": "Ionicons 4",
    "projectUrl": "https://ionicons.com/",
    "license": "MIT",
    "licenseUrl": "https://github.com/ionic-team/ionicons/blob/master/LICENSE"
  },
  {
    "id": "io5",
    "name": "Ionicons 5",
    "projectUrl": "https://ionicons.com/",
    "license": "MIT",
    "licenseUrl": "https://github.com/ionic-team/ionicons/blob/master/LICENSE"
  },
  {
    "id": "md",
    "name": "Material Design icons",
    "projectUrl": "http://google.github.io/material-design-icons/",
    "license": "Apache License Version 2.0",
    "licenseUrl": "https://github.com/google/material-design-icons/blob/master/LICENSE"
  },
  {
    "id": "ti",
    "name": "Typicons",
    "projectUrl": "http://s-ings.com/typicons/",
    "license": "CC BY-SA 3.0",
    "licenseUrl": "https://creativecommons.org/licenses/by-sa/3.0/"
  },
  {
    "id": "go",
    "name": "Github Octicons icons",
    "projectUrl": "https://octicons.github.com/",
    "license": "MIT",
    "licenseUrl": "https://github.com/primer/octicons/blob/master/LICENSE"
  },
  {
    "id": "fi",
    "name": "Feather",
    "projectUrl": "https://feathericons.com/",
    "license": "MIT",
    "licenseUrl": "https://github.com/feathericons/feather/blob/master/LICENSE"
  },
  {
    "id": "lu",
    "name": "Lucide",
    "projectUrl": "https://lucide.dev/",
    "license": "ISC",
    "licenseUrl": "https://github.com/lucide-icons/lucide/blob/main/LICENSE"
  },
  {
    "id": "gi",
    "name": "Game Icons",
    "projectUrl": "https://game-icons.net/",
    "license": "CC BY 3.0",
    "licenseUrl": "https://creativecommons.org/licenses/by/3.0/"
  },
  {
    "id": "wi",
    "name": "Weather Icons",
    "projectUrl": "https://erikflowers.github.io/weather-icons/",
    "license": "SIL OFL 1.1",
    "licenseUrl": "http://scripts.sil.org/OFL"
  },
  {
    "id": "di",
    "name": "Devicons",
    "projectUrl": "https://vorillaz.github.io/devicons/",
    "license": "MIT",
    "licenseUrl": "https://opensource.org/licenses/MIT"
  },
  {
    "id": "ai",
    "name": "Ant Design Icons",
    "projectUrl": "https://github.com/ant-design/ant-design-icons",
    "license": "MIT",
    "licenseUrl": "https://opensource.org/licenses/MIT"
  },
  {
    "id": "bs",
    "name": "Bootstrap Icons",
    "projectUrl": "https://github.com/twbs/icons",
    "license": "MIT",
    "licenseUrl": "https://opensource.org/licenses/MIT"
  },
  {
    "id": "ri",
    "name": "Remix Icon",
    "projectUrl": "https://github.com/Remix-Design/RemixIcon",
    "license": "Apache License Version 2.0",
    "licenseUrl": "http://www.apache.org/licenses/"
  },
  {
    "id": "fc",
    "name": "Flat Color Icons",
    "projectUrl": "https://github.com/icons8/flat-color-icons",
    "license": "MIT",
    "licenseUrl": "https://opensource.org/licenses/MIT"
  },
  {
    "id": "gr",
    "name": "Grommet-Icons",
    "projectUrl": "https://github.com/grommet/grommet-icons",
    "license": "Apache License Version 2.0",
    "licenseUrl": "http://www.apache.org/licenses/"
  },
  {
    "id": "hi",
    "name": "Heroicons",
    "projectUrl": "https://github.com/tailwindlabs/heroicons",
    "license": "MIT",
    "licenseUrl": "https://opensource.org/licenses/MIT"
  },
  {
    "id": "hi2",
    "name": "Heroicons 2",
    "projectUrl": "https://github.com/tailwindlabs/heroicons",
    "license": "MIT",
    "licenseUrl": "https://opensource.org/licenses/MIT"
  },
  {
    "id": "si",
    "name": "Simple Icons",
    "projectUrl": "https://simpleicons.org/",
    "license": "CC0 1.0 Universal",
    "licenseUrl": "https://creativecommons.org/publicdomain/zero/1.0/"
  },
  {
    "id": "sl",
    "name": "Simple Line Icons",
    "projectUrl": "https://thesabbir.github.io/simple-line-icons/",
    "license": "MIT",
    "licenseUrl": "https://opensource.org/licenses/MIT"
  },
  {
    "id": "im",
    "name": "IcoMoon Free",
    "projectUrl": "https://github.com/Keyamoon/IcoMoon-Free",
    "license": "CC BY 4.0 License",
    "licenseUrl": "https://github.com/Keyamoon/IcoMoon-Free/blob/master/License.txt"
  },
  {
    "id": "bi",
    "name": "BoxIcons",
    "projectUrl": "https://github.com/atisawd/boxicons",
    "license": "MIT",
    "licenseUrl": "https://github.com/atisawd/boxicons/blob/master/LICENSE"
  },
  {
    "id": "cg",
    "name": "css.gg",
    "projectUrl": "https://github.com/astrit/css.gg",
    "license": "MIT",
    "licenseUrl": "https://opensource.org/licenses/MIT"
  },
  {
    "id": "vsc",
    "name": "VS Code Icons",
    "projectUrl": "https://github.com/microsoft/vscode-codicons",
    "license": "CC BY 4.0",
    "licenseUrl": "https://creativecommons.org/licenses/by/4.0/"
  },
  {
    "id": "tb",
    "name": "Tabler Icons",
    "projectUrl": "https://github.com/tabler/tabler-icons",
    "license": "MIT",
    "licenseUrl": "https://opensource.org/licenses/MIT"
  },
  {
    "id": "tfi",
    "name": "Themify Icons",
    "projectUrl": "https://github.com/lykmapipo/themify-icons",
    "license": "MIT",
    "licenseUrl": "https://github.com/thecreation/standard-icons/blob/master/modules/themify-icons/LICENSE"
  },
  {
    "id": "rx",
    "name": "Radix Icons",
    "projectUrl": "https://icons.radix-ui.com",
    "license": "MIT",
    "licenseUrl": "https://github.com/radix-ui/icons/blob/master/LICENSE"
  },
  {
    "id": "pi",
    "name": "Phosphor Icons",
    "projectUrl": "https://github.com/phosphor-icons/core",
    "license": "MIT",
    "licenseUrl": "https://github.com/phosphor-icons/core/blob/main/LICENSE"
  },
  {
    "id": "lia",
    "name": "Icons8 Line Awesome",
    "projectUrl": "https://icons8.com/line-awesome",
    "license": "MIT",
    "licenseUrl": "https://github.com/icons8/line-awesome/blob/master/LICENSE.md"
  }
]
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
;// CONCATENATED MODULE: ./node_modules/react-icons/lib/iconContext.mjs

var DefaultContext = {
  color: undefined,
  size: undefined,
  className: undefined,
  style: undefined,
  attr: undefined
};
var IconContext = react.createContext && /*#__PURE__*/react.createContext(DefaultContext);
;// CONCATENATED MODULE: ./node_modules/react-icons/lib/iconBase.mjs
var _excluded = ["attr", "size", "title"];
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return typeof key === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (typeof input !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (typeof res !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }


function Tree2Element(tree) {
  return tree && tree.map((node, i) => /*#__PURE__*/react.createElement(node.tag, _objectSpread({
    key: i
  }, node.attr), Tree2Element(node.child)));
}
function GenIcon(data) {
  // eslint-disable-next-line react/display-name
  return props => /*#__PURE__*/react.createElement(IconBase, _extends({
    attr: _objectSpread({}, data.attr)
  }, props), Tree2Element(data.child));
}
function IconBase(props) {
  var elem = conf => {
    var {
        attr,
        size,
        title
      } = props,
      svgProps = _objectWithoutProperties(props, _excluded);
    var computedSize = size || conf.size || "1em";
    var className;
    if (conf.className) className = conf.className;
    if (props.className) className = (className ? className + " " : "") + props.className;
    return /*#__PURE__*/react.createElement("svg", _extends({
      stroke: "currentColor",
      fill: "currentColor",
      strokeWidth: "0"
    }, conf.attr, attr, svgProps, {
      className: className,
      style: _objectSpread(_objectSpread({
        color: props.color || conf.color
      }, conf.style), props.style),
      height: computedSize,
      width: computedSize,
      xmlns: "http://www.w3.org/2000/svg"
    }), title && /*#__PURE__*/react.createElement("title", null, title), props.children);
  };
  return IconContext !== undefined ? /*#__PURE__*/react.createElement(IconContext.Consumer, null, conf => elem(conf)) : elem(DefaultContext);
}
;// CONCATENATED MODULE: ./node_modules/react-icons/lib/index.mjs




/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [4738,594,3662,4396,4817,8527,8547,1664,1448,5534,7947,4273,2036,3920,7801,5861,8557,5925,9774,2888,179], function() { return __webpack_exec__(89886); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);